import {MemberInput} from './types';

export const getNonemptyMembers = (members: MemberInput[]): MemberInput[] => {
  const nonEmpty = members.filter(
    m =>
      (m.numberInfo?.nationalNumberFormatted ?? '').length > 0 ||
      m.startDate !== undefined,
  );
  return nonEmpty;
};
